const SVG_NS = 'http://www.w3.org/2000/svg';

/**
 * Factory pro vytváření SVG path elementů
 * Separuje logiku vytváření DOM od event handlerů
 */
export default class SVGPathFactory {
  /**
   * Vytvoří SVG path element (bez event handlerů)
   * @param {Object} config - konfigurace path
   * @param {string} config.id - ID elementu
   * @param {string} config.d - path data (SVG path commands)
   * @param {string} config.color - barva (CSS třída)
   * @param {boolean} config.clone - je to klon? (default: false)
   * @returns {SVGPathElement}
   */
  static create({
    id,
    d,
    color = 'yellow',
    clone = false,
  }) {
    const path = document.createElementNS(SVG_NS, 'path');

    path.setAttribute('data-svg-path', '');
    path.setAttribute('d', d || '');
    path.classList.add('svg-path');

    if (id) path.id = id;

    if (color) path.classList.add(color);

    if (clone) {
      path.setAttribute('data-svg-clone', 'true');
    }

    return path;
  }
}
